import jwtDecode from 'jwt-decode';
import * as types from 'actions/auth';

const initialState = {
    user: null
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN_SUCCESS:
		case types.USER_ACTIVATION_SUCCESS:
            return {
                ...state,
                user: jwtDecode(action.payload.token).username
            };
        case types.LOGOUT_REQUEST:
            return {
                ...state,
                user: null
            };
        default:
            return state
    }
};

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js